document.addEventListener('DOMContentLoaded', function () {

  function customizeGiftCard() {

    document.querySelectorAll('product-card').forEach(function(card) {

      // SOLO E-GIFT CARD
      if (card.getAttribute('product-handle') !== 'e-gift-card') {
        return;
      }

      const productUrl = card.getAttribute('product-url');

      // Nasconde Quick View
      card.querySelectorAll('.quick-view-icon').forEach(function(el) {
        el.remove();
      });

      const button = card.querySelector('.product-card-item__form button[type="submit"]');

      if (!button || button.dataset.changed === 'true') return;

      button.dataset.changed = 'true';

      const text = button.querySelector('.btn--text');

      if (text) {
        text.textContent = 'Visualizza prodotto';
      }

      button.type = 'button';

      button.addEventListener('click', function(e) {
        e.preventDefault();
        window.location.href = productUrl;
      });
    });
  }

  customizeGiftCard();

  new MutationObserver(customizeGiftCard).observe(document.body, {
    childList: true,
    subtree: true
  });

});
